<template>
  <div class="body-wrapper">
    <Header :title="'Content Manager'" />
    
    <div v-if="contentType === 'text'">
      <TextEditor 
        v-for="section in sections" 
        :key="section.id"
        :type="section.doc_type"
        :heading="section.heading"
        :body="section.body"
        :id="section.id"
        :new="section.new || false" />
    </div>

    <div class="blog-creation" v-if="contentType === 'blog' && loaded">
      <div class="left">
        <label>Title</label>
        <input type="text" v-model="title" placeholder="Our top 5 tips for getting started in the gym"/>
        
        <label>URL (www.wotive.com/blog/...)</label>
        <input type="text" v-model="urlName" placeholder="tips-getting-in-the-gym"/>

        <label>Type</label>
        <select v-model="type">
          <option value="">Select type</option>
          <option v-for="type in types" :key="type" :value="type">{{type}}</option>
        </select>

        <label>Slug (Max 2 sentences)</label>
        <textarea v-model="slug" placeholder="Essential tips for beginners stepping into the gym for the first time! From setting realistic goals to listening to your body, this blog post offers invaluable guidance to kickstart your fitness journey with confidence and success."/>
        
        <label>Featured Image (2x1)</label>
        <div class="featured-image">
          <div class="preview-featured-img" v-if="featuredImageUrl">
            <img id="preview" :src="featuredImageUrl" />
          </div>
          <input
            class="featured-image"
            type="file"
            @change="featuredImageChange($event.target.files);"
            accept="image/*"
          />
        </div>

        <label>Author</label>
        <select v-model="authorName">
          <option value="Wotive">Wotive Official</option>
          <option value="Luke Dowding">Luke Dowding</option>
          <option value="Matt Blay">Matt Blay</option>
        </select>

        <label>Content</label>
        <TextEditor 
          type="blog"
          :body="blogContent"
          @saveBlog="saveBlog"
        />
      </div>
      <div class="right">
        <div class="media-lib">
          <label>Media Library</label>
          <div class="media-lib-holder">
            <input
              type="file"
              @change="filesChange($event.target.files);"
              accept="image/*"
              multiple="true"
            />
            <div class="preview-imgs">
              <div class="ind-img" v-for="(img, index) in existingPreviewImageUrls" :key="img">
                <div v-if="deletedImageCheck(img)">
                  <a @click="undoDeleteExistingImage(index)"><i class="fas fa-undo"></i></a>
                  <img id="preview" class="deleted" :src="img" />
                </div>
                <div v-else>
                  <a @click="deleteExistingImage(index)"><i class="fas fa-times"></i></a>
                  <img id="preview" :src="img" />
                </div>
              </div>
              <div class="ind-img" v-for="(img, index) in newPreviewImageUrls" :key="img">
                <a @click="deleteNewImage(index)"><i class="fas fa-times"></i></a>
                <img id="preview" :src="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="contentType === 'grid'">
      <GridEditor 
        :key="sections[0].id"
        :type="sections[0].doc_type"
        :heading="sections[0].heading"
        :id="sections[0].id" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { getDocumentDetails, createBlog, editBlog, getBlogDetails } from "@/api/requests";
import TextEditor from '../components/content_editor/TextEditor.vue';
import GridEditor from '../components/content_editor/GridEditor.vue';
import { BLOG_TYPES } from '@/constants';

export default {
  name: "ContentEditorDetails",

  data() {
    return {
      blogId: null,
      selectedTab: 'all',
      existingPreviewImageUrls: [],
      deletedPreviewImageUrls: [],
      newPreviewImageUrls: [],
      newPreviewImages: [],
      featuredImageUrl: null,
      featuredImage: null,
      urlName: '',
      title: '',
      type: 'News',
      slug: '',
      authorName: '',
      blogContent: null,
      loaded: false,
    };
  },

  components: {
    Header,
    TextEditor,
    GridEditor,
  },
  async mounted() {
    const type = this.$route.params.type;
    if (type == 'blog') {
      const blogId = this.$route.params.blogId;
      
      getBlogDetails(blogId).then(response => {
        this.$store.dispatch('content/setBlogDetails', response.data);

        this.blogId = blogId;
        this.urlName = this.blogDetails.url_name;
        this.title = this.blogDetails.title;
        this.type = this.blogDetails.blog_type;
        this.slug = this.blogDetails.slug;
        this.authorName = this.blogDetails.author.name;
        this.featuredImageUrl = this.url + this.blogDetails.featured_image;
        this.blogContent = this.blogDetails.content;
        
        this.blogDetails.content_images.forEach(image => {
          this.existingPreviewImageUrls.push(this.url + image);
        });

        this.loaded = true;
      }).catch(() => {
        // TODO errors
      });
    } else if (type !== 'new_blog') {
      getDocumentDetails(type).then(response => {
        this.$store.dispatch('content/setDetails', response.data);
        this.loaded = true;
      }).catch(() => {
        // TODO errors
      });
    } else {
      this.loaded = true;
    }
  },

  methods: {
    deletedImageCheck(image) {
      const index = this.deletedPreviewImageUrls.indexOf(image);
      return index > -1;
    },

    deleteNewImage(index) {
      this.$confirm(
        "Are you sure you want to delete this image?", 
        "DELETE IMAGE").then(() => {
        this.newPreviewImageUrls.splice(index, 1);
        this.newPreviewImages.splice(index, 1);
      });
    },

    deleteExistingImage(index) {
      this.$confirm(
        "Are you sure you want to delete this image?", 
        "DELETE IMAGE").then(() => {
          this.deletedPreviewImageUrls.push(this.existingPreviewImageUrls[index]);
      });
    },

    undoDeleteExistingImage(index) {
      let indexOfDeleted = this.deletedPreviewImageUrls.indexOf(this.existingPreviewImageUrls[index])
      this.deletedPreviewImageUrls.splice(indexOfDeleted, 1);
    },

    filesChange(fileList) {
      for (const file in fileList) {
        this.newPreviewImageUrls.push(URL.createObjectURL(fileList[file]));
        this.newPreviewImages.push(fileList[file]);
      }
    },

    featuredImageChange(fileList) {
      this.featuredImageUrl = URL.createObjectURL(fileList[0]);
      this.featuredImage = fileList[0];
    },

    saveBlog(blogContents) {
      if (this.blogId) {
        this.editExistingBlog(blogContents);
      } else {
        this.createNewBlog(blogContents);
      }
    },
    
    createNewBlog(blogContents) {
      let formData = new FormData();
      formData.append(
        "featured_image",
        this.featuredImage,
        this.featuredImage.name
      );

      let imageMap = {};
      for (const image in this.newPreviewImages) {
        formData.append(
          "image_" + image,
          this.newPreviewImages[image],
          this.newPreviewImages[image].name
        );
        imageMap["image_"+image] = this.newPreviewImageUrls[image];
      }

      const payload = {
        content: blogContents,
        url_name: this.urlName,
        title: this.title,
        blog_type: this.type,
        slug: this.slug,
        author_name: this.authorName,
        image_map: JSON.stringify(imageMap),
      };
      for (var key in payload) {
        formData.append(key, payload[key]);
      }

      createBlog(formData).then(() => {
        this.$toasted.global.app_success({
          message: "Blog has been created."
        });
        this.$router.push({ name: 'ContentEditor' });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to create blog."
        });
      });
    },

    editExistingBlog(blogContents) {
      let formData = new FormData();
      if (this.featuredImage) {
        formData.append(
          "featured_image",
          this.featuredImage,
          this.featuredImage.name
        );
      }
      let imageMap = {};
      for (const image in this.newPreviewImages) {
        formData.append(
          "image_" + image,
          this.newPreviewImages[image],
          this.newPreviewImages[image].name
        );
        imageMap["image_"+image] = this.newPreviewImageUrls[image];
      }

      let deletedImages = [];
      for (const deletedImage in this.deletedPreviewImageUrls) {
        const delImageUrl = this.deletedPreviewImageUrls[deletedImage];
        const index = this.existingPreviewImageUrls.indexOf(delImageUrl);
        if (index > -1) {
          deletedImages.push(index);
        }
      }

      console.log(deletedImages);

      const payload = {
        content: blogContents,
        url_name: this.urlName,
        title: this.title,
        blog_type: this.type,
        slug: this.slug,
        author_name: this.authorName,
        image_map: JSON.stringify(imageMap),
        deleted_image_indexes: JSON.stringify(deletedImages)
      };
      for (var key in payload) {
        formData.append(key, payload[key]);
      }

      editBlog(this.blogId, formData).then(() => {
        this.$toasted.global.app_success({
          message: "Blog has been updated."
        });
        this.$router.push({ name: 'ContentEditor' });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update blog."
        });
      });
    }
  },

  computed: {
    sections() {
      return this.$store.state.content.sections;
    },

    contentType() {
      if (['new_blog', 'blog'].includes(this.$route.params.type)) {
        return 'blog';
      }

      return this.$route.query.content;
    },

    defaultBody() {
      return '{"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":"Wotive blog post starts here..."}]}]}';
    },

    blogDetails() {
      return this.$store.state.content.blog;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },

    types() {
      return BLOG_TYPES.filter(t => t !== 'All types');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.action-buttons {
  position: fixed;
  right: $spacing-base;
  top: 116px;
}

label {
  color: #FFF;
  padding-top: 16px;

  &:first {
    padding-top: 0;
  }
}

.blog-creation {
  display: flex;

  label {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 2px;
    display: block;
  }

  .left {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 35%;

    input {
      width: 100%;
    }
    select {
      width: 100%;
    }
    textarea {
      width: 100%;
      height: 80px;
      resize: none;
    }

    .featured-image {
      width: 216px;
      height: 116px;
      position: relative;
      background: $sec0;

      .preview-featured-img {
        position: absolute;
        width: 100%;
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          padding: 8px;
          box-sizing: border-box;
          object-fit: cover;
        }
      }
      input {
        position: absolute;
        padding: 0;
        background: transparent;
      }
    }

    .preview-imgs {
      img {
        width: 200px;
        display: inline-block;
      }
    }

    .preview-author-img {
      img {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        display: inline-block;
      }
    }
  }
  .right {
    width: 100%;
    padding: 0 40px;

    .media-lib {
      width: 100%;
      min-height: 100px;
      margin-top: 460px;
      .media-lib-holder {
        background: $sec0;

        .preview-imgs {
          display: flex;
          gap: 16px;
          padding: 0 16px 16px 16px;
          flex-wrap: wrap;

          .ind-img {
            position: relative;
            a {
              position: absolute;
              right: 0;
              color: #FFF;
              width: 30px;
              height: 30px;
              align-items: center;
              align-self: center;
              justify-content: center;
              display: flex;
              cursor: pointer;
            }

            .deleted {
              opacity: 0.3;
            }
          }
          
          img {
            width: 200px;
            height: 100px;
          }
        }
        
      }
    }
  }
}
</style>
